import Plausible from './lib/tracker';
export default Plausible;
